const EN = {
    title: 'Cambio de',
    titleCreate: 'Creación de',
    title2: 'Contraseña',
    helperText: 'Tené en cuenta que no pueden ser datos personales ni números correlativos.',
    helperTextCreate: 'Generá una nueva contraseña para continuar. Tené en cuenta que no pueden ser datos personales ni números correlativos.',
    inputs: {
        password: {
            placeholder: 'Nueva contraseña'
        },
        confirmPassword: {
            placeholder: 'Confirmar nueva contraseña'
        },
    },
    help: {
        title: 'Debe tener, al menos:',
        list: {
            0: '8 caracteres.',
            1: 'Un carácter en minúscula.',
            2: 'Un carácter en mayúscula.',
            3: 'Un número.',
            4: 'Un carácter especial.'
        }
    },
    changePassword: {
        success: 'Su nueva contraseña fue creada exitosamente.',
        error: 'Las contraseñas no coinciden.'
    },
    recover: {
        success: 'El usuario ha sido validado correctamente.',
    }

};

export default EN;
